import { useState } from 'react';

export default function useInputWithError(initialState = '') {
  const [value, setValue] = useState(initialState);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState('');
  function setInputError(error: string) {
    setHasError(error !== '');
    setError(error);
  }
  return { value, setValue, hasError, error, setError: setInputError };
}
